import { action } from 'satcheljs';

export interface OnCopilotChatDrawerExpandRequestedMessage {
    targetWindow: Window;
}

// Fired when the user clicks Expand. Distinct from `onCopilotChatDrawerExpandedState`,
// which also fires from drag-resize. Subscribe here to react only to the explicit click.
export const onCopilotChatDrawerExpandRequested: (
    targetWindow: Window
) => OnCopilotChatDrawerExpandRequestedMessage = action(
    'onCopilotChatDrawerExpandRequested',
    (targetWindow: Window): OnCopilotChatDrawerExpandRequestedMessage => ({
        targetWindow,
    })
);
